import React from 'react';

const MOBILE_BREAKPOINT = 576;

export default function useResponsive() {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
}



// WEBPACK FOOTER //
// ./hooks/useResponsive.js